module.exports = __webpack_public_path__ + "static/media/LinkedIn.849869d9.png";